import ICommit from '@/store/contracts/commit'

const getDefaultState = () => {
    return {
        show_book: {},
        catalog_id: '',
        showInitialGreeting: false,
        showAvatarModal: false,
        showCategoriesModal: false,
        showAvatarAndCategoriesModal: false,
        index_text: -1,
        first_pass: true,
        testDiagnostic: [],
        show_top: false,
        answer_body: {
            bookUserId: null,
            diagnosticoPreguntaRespuesta: [],
            evaluationsIds: [],
        },
        openSurveyModal: false,
        current_text: {},
        index_ask: 0,
        mount_diagnostic: false,
        showInitialPoll: false,
        showFinishPreferencesModal: false,
        showFinishSurveyModal: false,
        showDiagnosticTutorialModal: false,
        showFinishOnboardingModal: false,
        bookAssigment: null,
        bookAssigLoaded: false,
        defaultAvatarPack: null,
    }
}
const Dashboard = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        show_InitialGreeting: (state: any) => {
            state.showInitialGreeting = !state.showInitialGreeting
        },
        show_AvatarModal: (state: any) => {
            state.showAvatarModal = !state.showAvatarModal
        },
        show_CategoriesModal: (state: any) => {
            state.showCategoriesModal = !state.showCategoriesModal
        },
        show_AvatarAndCategoriesModal: (state: any) => {
            state.showAvatarAndCategoriesModal = !state.showAvatarAndCategoriesModal
        },
        show_FinishPreferencesModal: (state: any) => {
            state.showFinishPreferencesModal = !state.showFinishPreferencesModal
        },
        show_FinishSurveyModal: (state: any) => {
            state.showFinishSurveyModal = !state.showFinishSurveyModal
        },
        show_DiagnosticTutorialModal: (state: any) => {
            state.showDiagnosticTutorialModal = !state.showDiagnosticTutorialModal
        },
        show_FinishOnBoardingModal: (state: any) => {
            state.showFinishOnboardingModal = !state.showFinishOnboardingModal
        },
        initTest: (state: any) => {
            state.index_text = 0
            state.current_text = state.testDiagnostic[state.index_text]
            state.answer_body.diagnosticoPreguntaRespuesta = []
        },
        mountDiagnostic: (state: any) => {
            state.mount_diagnostic = !state.mount_diagnostic
        },
        pendingDiagnosticData: (state: any, data: any) => {
            state.testDiagnostic = data.testDiagnostic
            state.answer_body.bookUserId = data.userId
            state.answer_body.evaluationsIds = data.testDiagnostic.map((item: any) => item.id)
        },
        show_InitialPoll: (state: any) => {
            state.showInitialPoll = !state.showInitialPoll
        },
        initialTour: (state: any) => {
            state.showAvatarModal = state.showCategoriesModal = state.showInitialPoll = state.mount_diagnostic = state.showFinishPreferencesModal = false
            state.showInitialGreeting = true
        },
        setDefaultAvatarPack(state: any, value: any) {
            state.defaultAvatarPack = value
        },
    },
    actions: {
        setPendingDiagnosticData({ commit }: ICommit, data: any) {
            commit('pendingDiagnosticData', data)
        },
        mountDiagnostic({ commit }: ICommit) {
            commit('mountDiagnostic')
        },
        initTest({ commit }: ICommit) {
            commit('initTest')
        },
        showFirtsPass({ commit }: ICommit) {
            commit('show_InitialGreeting')
        },
        showAvatars({ commit }: ICommit) {
            commit('show_AvatarModal')
        },
        showCategories({ commit }: ICommit) {
            commit('show_CategoriesModal')
        },
        show_AvatarAndCategoriesModal({ commit }: ICommit) {
            commit('show_AvatarAndCategoriesModal')
        },
        showFinishPreferencesModal: ({ commit }: ICommit) => {
            commit('show_FinishPreferencesModal')
        },
        showFinishSurveyModal: ({ commit }: ICommit) => {
            commit('show_FinishSurveyModal')
        },
        showDiagnosticTutorialModal: ({ commit }: ICommit) => {
            commit('show_DiagnosticTutorialModal')
        },
        showFinishOnBoardingModal: ({ commit }: ICommit) => {
            commit('show_FinishOnBoardingModal')
        },
        showInitialPoll({ commit }: ICommit) {
            commit('show_InitialPoll')
        },
        initalTour({ commit }: ICommit) {
            commit('initialTour')
        },
        notStartTour({ state }: any) {
            state.showInitialGreeting = state.showAvatarModal = state.showCategoriesModal = state.showInitialPoll = state.mount_diagnostic = false
        },
        setBookAssigment({ commit }: ICommit, value: any) {
            commit('setBookAssigment', value)
        },
        setDefaultAvatarPack({ commit }: ICommit, value: any) {
            commit('setDefaultAvatarPack', value)
        },
        insertDiagnosticoPreguntaRespuesta({ state }: any, element: any) {
            state.answer_body.diagnosticoPreguntaRespuesta.push(element)
        },
        setBookUserIdForDiagnostic({ state }: any, bookUserId: any) {
            state.answer_body.bookUserId = bookUserId
        },
        resetDashboardState({ state }: any) {
            Object.assign(state, getDefaultState())
        },
    },
}

export default Dashboard
